export default {
  functionKey: "MAX",
  title: "MAX",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  description: "Retourne la valeur maximale parmi plusieurs colonnes pour chaque ligne. Ajoutez les colonnes en Origine.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `var _mx=[${cols.join(',')}].map(function(v){return parseFloat(v);}).filter(function(v){return !isNaN(v);}); ${destination}=_mx.length>0?String(Math.max.apply(null,_mx)):'';`;
    return { displayCode: safeCode, safeCode };
  }
}
